import { PropTypes } from 'prop-types'

const Button = ({ handleClick, icon, disabled, className, title, loading, style, loadingText }) => {
  return (
    <button onClick={handleClick} style={style} disabled={disabled} className={className ? className : 'btn-icon'}> {icon && icon}  {loading ? loadingText ? loadingText : "Kaydediliyor..." : title && title}</button>
  )
}

Button.propTypes = {
  handleClick: PropTypes.func,
  icon: PropTypes.any,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  loading: PropTypes.bool,
  style: PropTypes.any,
  loadingText: PropTypes.string
}
export default Button